export default [
  {
    name: 'Shop.Goods',
    path: 'goods',
    component: () => import('./components/goods/List'),
  },
  {
    name: 'Shop.Goods.Edit',
    path: 'goods/:id?/edit',
    props: true,
    component: () => import('./components/goods/Edit'),
  },
  {
    name: 'Shop.Categories',
    path: 'categories',
    component: () => import('./components/categories/List'),
  },
  {
    name: 'Shop.Categories.Edit',
    path: 'categories/:id?/edit',
    props: true,
    component: () => import('./components/categories/Edit'),
  },
  {
    name: 'Shop.Orders',
    path: 'orders',
    component: () => import('./components/orders/List'),
  },
  {
    name: 'Shop.Orders.Edit',
    path: 'orders/:id?/edit',
    props: true,
    component: () => import('./components/orders/Edit'),
  },
]
